export default "__VITE_ASSET__3de15ea9__"